import React from 'react';
import axios from 'axios';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import { BlockContainer } from '../../components/layouts';
import type { PagesQuery } from '../../graphql/generated/schema';
import { DynamicForm } from '../../components';
import styles from './styles.module.scss';

export const LeadFormBlock: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'LeadFormBlock'>> = async ({
  blockSettings,
  leadForm,
}) => {
  const sourceWithQuestions = await axios.get(`${process.env.NEXT_PUBLIC_DEV_CLIENT_URL || process.env.NEXT_PUBLIC_CLIENT_URL}/api/lead-form/get-form`, {
    params: {
      leadFormId: leadForm?.id,
    },
  });

  if (!leadForm) {
    return null;
  }

  return (
    <BlockContainer
      blockSettings={blockSettings}
    >
      <div className={styles.container}>
        <DynamicForm
          isEmbedded
          questions={sourceWithQuestions.data.questions}
          leadFormId={leadForm?.id}
        />
      </div>
    </BlockContainer>
  );
};
